import React, { useState, useEffect } from "react";
import { Form, Col, Modal } from "react-bootstrap";
import StringHtmlToReact from "../StringHtmlToReact";
import {
  SimpleFieldType,
  PhoneFieldType,
  DobPropsType,
  EmailFieldType,
  StateFieldType,
} from "./types";
import $ from "jquery";
let secondPhone: any, thirdPhone: any;

//norma text fields
export const SimpleField: React.FC<SimpleFieldType> = ({
  fieldType,
  type = "text",
  id,
  label,
  placeholder,
  errorMessage,
  pattern,
  value,
  onChange,
  initialValue,
  isInValid,
  onBlur,
}) => {
  useEffect(() => {
    if (initialValue) {
      // onChange(initialValue);
    }
  }, [initialValue, onChange]);

  const handleKeyUp = (e: any) => {
    if (e.target.id === "First Name" || e.target.id === "Last Name") {
      const pt = /^[A-Za-z\s]+$/;
      if (e.target.value === "") {
        return true;
      } else {
        if (pt.test(e.target.value) && (e.which < 48 || e.which > 57)) {
          return true;
        } else {
          e.preventDefault();
          return false;
        }
      }
    }
    // prints either LoginInput or PwdInput
  };

  return (
    <Form.Group
      as={Col}
      lg="12"
      className="ga-field"
      controlId={`validationCustom${fieldType}`}
    >
      <Form.Label className="ga-form-label">{label}</Form.Label>
      <Form.Control
        aria-label={label}
        placeholder={placeholder}
        isInvalid={isInValid}
        className="ga-text"
        type={type}
        pattern={pattern}
        value={value}
        defaultValue={initialValue}
        onKeyPress={handleKeyUp}
        onBlur={onBlur}
        onChange={(v: any) => {
          onChange(v.target.value);
          if (v.target.id == "field_bonus_round_solution" && v.target.value !== "") {
            let element = (document.getElementById("field_second_bonus_solution") as HTMLInputElement);
            element.required = false;
          }
          else if (v.target.id == "field_bonus_round_solution" && v.target.value == "") {
            let element = (document.getElementById("field_second_bonus_solution") as HTMLInputElement);
            element.required = true;
          }

          if (v.target.id == "field_second_bonus_solution" && v.target.value !== "") {
            let element = (document.getElementById("field_bonus_round_solution") as HTMLInputElement);
            element.required = false;
          }
          else if (v.target.id == "field_second_bonus_solution" && v.target.value == "") {
            let element = (document.getElementById("field_bonus_round_solution") as HTMLInputElement);
            element.required = true;
          }

        }}
        required
        id={id ? id : label.includes("Code") ? "zip_code" : label}
      />
      <Form.Control.Feedback className="ga-error" type="invalid">
        {errorMessage}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

//dropdowns

export const GenderField: React.FC<SimpleFieldType> = ({
  fieldType: type,
  label,
  errorMessage,
  initialValue,
  onChange,
}) => {
  useEffect(() => {
    if (initialValue) {
      onChange(initialValue);
    }
  }, [initialValue, onChange]);
  return (
    label != "" ? (
      <Form.Group
        as={Col}
        lg="12"
        className="ga-field"
        controlId={`validationCustom${type}`}
      >
        <Form.Label className="ga-form-label">{label}</Form.Label>
        <Form.Control
          as="select"
          className="ga-text"
          required
          defaultValue={initialValue || ""}
          onChange={(v: any) => onChange(v.target.value)}
        >
          <option disabled value="">
            select an option
          </option>
          <option value="f">Female</option>
          <option value="m">Male </option>
        </Form.Control>
        <Form.Control.Feedback className="ga-error" type="invalid">
          {errorMessage}
        </Form.Control.Feedback>
      </Form.Group>
    ) : null
  );
};

export const PhoneField: React.FC<PhoneFieldType> = ({
  fieldType: type,
  label,
  errorMessage,
  smsOptin,
  smsChecked,
  initialValue,
  onChange,
  onSelectChange,
}) => {
  const [countryCode, setCountryCode] = useState<string>("");
  const [areaCode, setAreaCode] = useState<number>();
  useEffect(() => {
    if (initialValue) {
      if (
        (initialValue.length === 11 && initialValue.startsWith("1")) ||
        (initialValue.length === 12 && initialValue.startsWith("+1"))
      ) {
        setCountryCode("+1");
      }
      let s = initialValue.replace(/[^0-9]*/, "");
      s = s.substring(s.length - 10);
      setAreaCode(+s.substring(s.length - 10, s.length));

      onChange(initialValue);
    }
  }, [initialValue, onChange]);

  function handleKeyPress(event: any) {
    if (event.target.value.length === event.target.maxLength - 1) {
      if (event.target.id === "phone1") {
        secondPhone.focus();
      } else if (event.target.id === "phone2") {
        thirdPhone.focus();
      }
    }
  }

  useEffect(() => {
    if (initialValue) {
      onChange(initialValue);
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [areaCode, countryCode, initialValue, onChange]);

  return (
    <>
      <Form.Group as={Col} lg="12" className="ga-field ga-phone">
        <Form.Label className="ga-form-label">{label}</Form.Label>
        <Form.Control
          ref={(c: any) => (secondPhone = c)}
          className="ga-text"
          onKeyPress={handleKeyPress}
          type="text"
          defaultValue={initialValue}
          onChange={(e) => onChange(e.target.value)}
          placeholder={type}
          id={"phone2"}
          required
        />
        <Form.Control.Feedback className="ga-error" type="invalid">
          {errorMessage}
        </Form.Control.Feedback>
      </Form.Group>
      {smsOptin && (
        <Form.Group>
          <Form.Check
            label={smsOptin}
            defaultChecked={smsChecked}
            onClick={(e: any) => onSelectChange(e.target.checked)}
          />
        </Form.Group>
      )}
    </>
  );
};

const monthsAbbrvs = [
  "JAN",
  "FEB",
  "MAR",
  "APR",
  "MAY",
  "JUN",
  "JULY",
  "AUG",
  "SEPT",
  "OCT",
  "NOV",
  "DEC",
];
const addZero = (i: number) => (i < 10 ? "0" + i : i);
export const DobField: React.FC<DobPropsType> = ({
  fieldType: type,
  label,
  errorMessage,
  initialDay,
  initialMonth,
  initialYear,
  onChange,
}) => {
  const [daysInMonth, setDaysInMonth] = useState<number[]>([]);
  const [day, setDay] = useState<number>(-1);
  const [month, setMonth] = useState<number>(-1);
  const [year, setYear] = useState<number>();
  // set initial values
  useEffect(() => {
    if (typeof initialDay === "number") {
      setDay(initialDay);
    }
    if (typeof initialMonth === "number") {
      // JavaScript month is 0 - 11 indexed
      setMonth(initialMonth - 1);
    }
    if (typeof initialYear === "number") {
      setYear(initialYear);
    }
  }, [initialDay, initialMonth, initialYear, onChange]);
  // update days of the month drop down when year or month changes
  useEffect(() => {
    const _year = year ? year : 1970;
    const _month = month > -1 ? month : new Date().getMonth();
    const _daysInMonth = new Date(_year, _month + 1, 0).getDate();
    if (day > _daysInMonth) {
      setDay(_daysInMonth);
    }
    if (_daysInMonth !== daysInMonth.length) {
      setDaysInMonth(new Array(_daysInMonth).fill(0).map((_, i) => i));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [month, year]);
  // update parent when data changes, if it is somewhat valid
  useEffect(() => {
    if (year && day > -1 && month > -1) {
      // const d = new Date(year, month, day);
      const d = `${addZero(month + 1)}/${addZero(day)}/${year}`;
      onChange(d);
    }
  }, [month, year, day, onChange]);

  return (
    <Form.Group
      as={Col}
      lg="12"
      className="ga-field ga-dob"
      controlId={`validationCustom${type}`}
    >
      <Form.Label className="ga-form-label">{label}</Form.Label>

      <Form.Control
        id="select-choice"
        as="select"
        required
        value={month > -1 ? month : ""}
        onChange={(v: any) => setMonth(+v.target.value)}
        aria-label={label+", Select Month"}
      >
        <option disabled value="" id="year">
          Month
        </option>
        {monthsAbbrvs.map((v, i) => (
          <option key={i} value={i} id={v}>
            {v}
          </option>
        ))}
      </Form.Control>
      <Form.Control
        aria-label="Select Day"
        as="select"
        required
        value={day > -1 ? day : ""}
        onChange={(v: any) => setDay(+v.target.value)}
      >
        <option disabled value="">
          Day
        </option>
        {daysInMonth.map((v, i) => (
          <option key={i} value={i + 1}>
            {addZero(i + 1)}
          </option>
        ))}
      </Form.Control>
      <Form.Control
        aria-label="Enter Year"
        className="ga-text"
        type="text"
        onChange={(v: any) => setYear(+v.target.value)}
        maxLength={4}
        pattern={"[0-9]{4}"}
        required
        defaultValue={year}
      />
      <Form.Control.Feedback className="ga-error" type="invalid">
        {errorMessage}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export const EmailField: React.FC<EmailFieldType> = ({
  fieldType: type,
  label,
  confirmLabel,
  errorMessage,
  confirmErrorMessage,
  initialValue,
  onChange,
  placeholder,
}) => {
  useEffect(() => {
    if (initialValue) {
      onChange(initialValue);
    }
  }, [initialValue, onChange]);
  const [email, setEmail] = useState(initialValue ? initialValue : "");
  const [dirty, setDirty] = useState(false);
  const [validConEmail, setValidConEmail] = useState(false);
  const [confirmEmail, setConfirmEmail] = useState(
    initialValue ? initialValue : ""
  );

  const checkEmail = (v: any) => {
    if (v !== confirmEmail) {
      setValidConEmail(true);
      (document.getElementById(
        "Confirm Email"
      ) as HTMLInputElement).classList.remove("is-valid");
      (document.getElementById(
        "Confirm Email"
      ) as HTMLInputElement).classList.add("email-invalid");
    } else {
      setValidConEmail(false);
    }
  };
  const checkEmailConfirm = (v: any) => {
    if (v !== email) {
      setValidConEmail(true);
      (document.getElementById(
        "Confirm Email"
      ) as HTMLInputElement).classList.remove("is-valid");
      (document.getElementById(
        "Confirm Email"
      ) as HTMLInputElement).classList.add("email-invalid");
    } else {
      setValidConEmail(false);
    }
  };

  return (
    <>
      <SimpleField
        fieldType={type}
        label={label}
        placeholder={placeholder}
        pattern="^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
        type="email"
        errorMessage={errorMessage}
        initialValue={initialValue}
        id="Email"
        onChange={async (v) => {
          checkEmail(v);
          await setEmail(v);
          await onChange(v);
        }}
      />
      <SimpleField
        fieldType={`confirm-${type}`}
        label={confirmLabel}
        pattern="^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
        placeholder={placeholder}
        type="email"
        initialValue={initialValue}
        isInValid={validConEmail}
        id="Confirm Email"
        onChange={(e) => {
          checkEmailConfirm(e);
          setConfirmEmail(e);
        }}
        errorMessage={confirmErrorMessage}
        onBlur={() => setDirty(true)}
      />
    </>
  );
};

export const StateField: React.FC<StateFieldType> = ({
  fieldType: type,
  id,
  label,
  includedStates,
  initialValue,
  onChange,
  placeholder,
}) => {
  const states_arr: any = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District Of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
    AB: "Alberta",
    BC: "British Columbia",
    MB: "Manitoba",
    NB: "New Brunswick",
    NF: "Newfoundland",
    NT: "Northwest Territories",
    NS: "Nova Scotia",
    NU: "Nunavut",
    ON: "Ontario",
    PE: "Prince Edward Island",
    SK: "Saskatchewan",
    YT: "Yukon Territory",
  };
  let state_arr: any = [];
  if (state_arr.length == 0) {
    for (let key in states_arr) {
      let value = states_arr[key];
      state_arr.push(value);
      // setStates(state_arr);
    }
  }
  const [state, setstate] = useState("");
  const [_states, setStates] = useState();
  useEffect(() => {
    if (initialValue && state == "") {
      onChange(initialValue);
    }
  }, [includedStates, initialValue, onChange, states_arr]);

  return (
    <Form.Group
      as={Col}
      lg="12"
      className="ga-field"
      controlId={`validationCustom${type}`}
    >
      <Form.Label className="ga-form-label">{label}</Form.Label>

      <Form.Control
        as="select"
        required
        value={state ? state : state_arr.includes(initialValue) ? initialValue : ''}
        onChange={(v: any) => {
          setstate(v.target.value);
          onChange(v.target.value);
        }}
      >
        <option disabled value=''> -- select -- </option>
        {state_arr &&
          state_arr.length > 0 &&
          state_arr.map((v: any, i: any) => (
            <option key={v} value={v} selected={v === initialValue}>
              {v}
            </option>
          ))}
      </Form.Control>
    </Form.Group>
  );
};

export const InEligbleAlert = ({ message = "" }) => (
  <div className="giveaway_not_eligible container">
    <Modal.Dialog>
      <Modal.Body>
        <StringHtmlToReact stringHtml={message} />
      </Modal.Body>
    </Modal.Dialog>
  </div>
);
